export enum SessionCallStates {
  Initial = "initial",
  Loading = "loading",
  Done = "done",
}
